<template>
  <div class="election-map-toolbar" v-if="show">
    <div class="election-map-toolbar__legend">
      <div class="election-map-toolbar__label" :style="democratLabelStyleModifiers">
        Democratic {{ democraticCounters.total + democraticCounters.predefinedReal }}
      </div>
      <div class="election-map-toolbar__label" :style="republicanLabelStyleModifiers">
        {{ republicanCounters.total + republicanCounters.predefinedReal }} Republican
      </div>
    </div>
    <div class="election-map-toolbar__bar" :style="barStyleModifiers">
      <div class="election-map-toolbar__line">
        <div class="election-map-toolbar__line-content">
          <div class="election-map-toolbar__line-label election-map-toolbar__line-label--center">
            {{ majorityText }}
          </div>
        </div>
      </div>
      <div
        v-if="isSenate"
        class="election-map-toolbar__bar-section election-map-toolbar__bar-section--democratic-stripped"
        :style="democraticPredefinedBarSectionStyleModifiers"
        :title="democraticCounters.predefinedReal"
      >
        <span v-if="showDemocraticPredefinedText">
          34 + 2
          <div
            class="election-map-toolbar__bar-section-label election-map-toolbar__bar-section-label--right"
          >
            No election
          </div>
        </span>
        <span v-else>&nbsp;</span>
      </div>
      <div
        class="election-map-toolbar__bar-section election-map-toolbar__bar-section--democratic"
        :style="democraticHighBarSectionStyleModifiers"
        :title="democraticCounters.high"
      >
        <span v-if="showDemocraticHighText">
          {{ democraticCounters.high }}
        </span>
        <span v-else>&nbsp;</span>
      </div>
      <div
        class="election-map-toolbar__bar-section election-map-toolbar__bar-section--democratic"
        :style="democraticMediumBarSectionStyleModifiers"
        :title="democraticCounters.medium"
      >
        <span v-if="showDemocraticMediumText">
          {{ democraticCounters.medium }}
        </span>
        <span v-else>&nbsp;</span>
      </div>
      <div
        class="election-map-toolbar__bar-section election-map-toolbar__bar-section--democratic"
        :style="democraticLowBarSectionStyleModifiers"
        :title="democraticCounters.low"
      >
        <span v-if="showDemocraticLowText">
          {{ democraticCounters.low }}
        </span>
        <span v-else>&nbsp;</span>
      </div>
      <div
        class="election-map-toolbar__bar-section election-map-toolbar__bar-section--republican"
        :style="republicanLowBarSectionStyleModifiers"
        :title="republicanCounters.low"
      >
        <span v-if="showRepublicanLowText">
          {{ republicanCounters.low }}
        </span>
        <span v-else>&nbsp;</span>
      </div>
      <div
        class="election-map-toolbar__bar-section election-map-toolbar__bar-section--republican"
        :style="republicanMediumBarSectionStyleModifiers"
        :title="republicanCounters.medium"
      >
        <span v-if="showRepublicanMediumText">
          {{ republicanCounters.medium }}
        </span>
        <span v-else>&nbsp;</span>
      </div>
      <div
        class="election-map-toolbar__bar-section election-map-toolbar__bar-section--republican"
        :style="republicanHighBarSectionStyleModifiers"
        :title="republicanCounters.high"
      >
        <span v-if="showRepublicanHighText">
          {{ republicanCounters.high }}
        </span>
        <span v-else>&nbsp;</span>
      </div>
      <div
        v-if="isSenate"
        class="election-map-toolbar__bar-section election-map-toolbar__bar-section--republican-stripped"
        :style="republicanPredefinedBarSectionStyleModifiers"
        :title="republicanCounters.predefinedReal"
      >
        <span v-if="showRepublicanPredefinedText">
          <div
            class="election-map-toolbar__bar-section-label election-map-toolbar__bar-section-label--left"
          >
            No election
          </div>
          {{ republicanCounters.predefinedReal }}
        </span>
        <span v-else>&nbsp;</span>
      </div>
    </div>
  </div>
</template>
<script src="./election-map-toolbar.js"></script>
<style src="./election-map-toolbar.scss" lang="scss"></style>
